import { render, staticRenderFns } from "./usersSetting.vue?vue&type=template&id=b1d5152c&scoped=true"
import script from "./usersSetting.vue?vue&type=script&lang=js"
export * from "./usersSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d5152c",
  null
  
)

export default component.exports